export default __webpack_public_path__ + "static/media/StudentLandingWhite.e49ca6aa.svg";